<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-17">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/ChapterOne#Anchor-1">CHAPTER ONE</a></p>
<p class="TOCitem"><a href="#/ChapterTwo#Anchor-1">CHAPTER TWO</a></p>
<p class="TOCitem"><span href="#/ChapterThree#Anchor-1" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="TOCitem"><span href="#/ChapterFour#Anchor-1" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="TOCitem"><span href="#/ChapterFive#Anchor-1" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="TOCitem"><span href="#/ChapterSix#Anchor-1" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="TOCitem"><span href="#/ChapterSeven#Anchor-1" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="TOCitem"><span href="#/ChapterEight#Anchor-1" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="TOCitem"><span href="#/ChapterNine#Anchor-1" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="TOCitem"><span href="#/ChapterTen#Anchor-1" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="TOCitem"><span href="#/ChapterEleven#Anchor-1" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="TOCitem"><span href="#/ChapterTwelve#Anchor-1" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="TOCitem"><span href="#/ChapterThirteen#Anchor-1" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
<p class="TOCitem"><span href="#/ChapterFourteen#Anchor-1" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="TOCitem"><span href="#/ChapterFifteen#Anchor-1" title="Link target outside of Sample">CHAPTER FIFTEEN</span></p>
<p class="TOCitem"><span href="#/Epilogue#Anchor-1" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="TOCitem"><span href="#/Excerpt#Anchor-1" title="Link target outside of Sample">EXCERPT FROM <em>SHACKLED TO THE SHEIKH</em> BY TRISH MOREY</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?08a4f9f9